export const SHOW_LOADING = 'SHOW_LOADING';
export const SET_DRAGGABLE = 'SET_DRAGGABLE';
export const SET_BOT = 'SET_BOT';
export const BOT_LIST_SUCCESS = 'BOT_LIST_SUCCESS';
export const BOT_FAIL = 'BOT_FAIL';
export const CREATE_NEW_BOT = 'CREATE_NEW_BOT';
export const ENTITY_LIST = 'ENTITY_LIST';
export const CREATE_NEW_ENTITY = 'CREATE_NEW_BOT';
export const INTENT_LIST = 'INTENT_LIST';
export const SET_AGENT_ID = 'SET_AGENT_ID';
export const DOMAIN_LIST = 'DOMAIN_LIST';
export const GET_SURVEY = 'GET_SURVEY';
export const UPDATE_SURVEY = 'UPDATE_SURVEY';
export const POST_SURVEY = 'POST_SURVEY';
export const SAVE_SURVEY = 'SAVE_SURVEY';
export const GET_SYSTEM_VARS="GET_SYSTEM_VARS"
export const SAVE_SYSTEM_VARS="SAVE_SYSTEM_VARS"
export const DELETE_SURVEY="DELETE_SURVEY"
export const RESET_BOT= "RESET_BOT"
export const GET_FAQS="GET_FAQS"
export const SAVE_FAQS="SAVE_FAQS"
export const GET_SMALL_TALKS="GET_SMALL_TALKS"
export const SAVE_SMALL_TALKS="SAVE_SMALL_TALKS"
export const GET_BOT_SETTINGS="GET_BOT_SETTINGS"
export const SAVE_BOT_SETTINGS="SAVE_BOT_SETTINGS"
export const UPDATE_BOT_SETTINGS="UPDATE_BOT_SETTINGS"
export const SET_BOT_SETTINGS_LOADING="SET_BOT_SETTINGS_LOADING"
export const SET_BOT_SETTINGS_UPDATING="SET_BOT_SETTINGS_UPDATING"